import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/* First 3 characters, then asterisks. 'Rohit Sharma' -> 'Roh*** Sha***' */
export const maskName = (name) => {
  if (!name) return "—";
  return String(name)
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => (part.length <= 3 ? `${part}***` : `${part.slice(0, 3)}***`))
    .join(" ");
};

/* 'rohit@gmail.com' -> 'roh***@***.com' */
export const maskEmail = (email) => {
  if (!email) return "—";
  const raw = String(email);
  const [local, domain = ""] = raw.split("@");
  const head = local.slice(0, 3);
  const dot = domain.lastIndexOf(".");
  const tld = dot > -1 ? domain.slice(dot) : "";
  return `${head}***@***${tld}`;
};

/* A masked value with its own eye toggle. Each instance reveals only its own value. */
export const Masked = ({ value, kind = "name", testid, className = "" }) => {
  const [shown, setShown] = useState(false);
  if (!value) return <span className={className}>—</span>;

  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
      <span className="truncate" data-testid={testid}>
        {shown ? value : kind === "email" ? maskEmail(value) : maskName(value)}
      </span>
      <button
        type="button"
        data-testid={testid ? `${testid}-eye` : undefined}
        aria-label={shown ? "Hide" : "Reveal"}
        title={shown ? "Hide" : "Reveal"}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShown((v) => !v);
        }}
        className="shrink-0 text-zinc-500 hover:text-emerald-300 transition-colors duration-200"
      >
        {shown ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
      </button>
    </span>
  );
};
